import { ReactNode, VFC } from 'react';
import Tooltip from '@adsk/alloy-react-tooltip';
import Theme from '@adsk/alloy-react-theme';
import { toLongDate, isLate } from '../../helpers/date-helpers';
import { Rfi } from '../../sdk/types/common/rfi';
import { useDueDateTimezone } from '../../hooks/useDueDateTimezone';
import { translate } from '../../helpers';

export type DueDateCellProps = {
  rowData: Pick<Rfi, 'closedAt' | 'dueDate' | 'createdAt'>;
};

const TOOLTIP_STYLE = { borderRadius: '4px' };

export const DueDateCell: VFC<DueDateCellProps> = ({ rowData }) => {
  const { dueDate, closedAt, createdAt } = rowData;
  const { dueDateTimeZone } = useDueDateTimezone(createdAt);

  const isClosed = !!closedAt;
  const tooltipContent: ReactNode = dueDateTimeZone ? translate('tooltips.dueDate') : null;

  return dueDate ? (
    <Tooltip content={tooltipContent} placement={Tooltip.PLACEMENTS.TOP} style={TOOLTIP_STYLE}>
      <span
        css={[
          Theme.typography.bodyMedium,
          {
            ...(!isClosed &&
              isLate(dueDate) && {
                color: Theme.colors.red700,
              }),
            whiteSpace: 'nowrap',
          },
        ]}
      >
        {toLongDate(dueDate, dueDateTimeZone || 'UTC')}
      </span>
    </Tooltip>
  ) : (
    <span>-</span>
  );
};
